import { computed } from "vue";
import { useClientComponentTypes } from "./useClientComponentTypes";
import { useDefaultComponentTypes } from "./useDefaultComponentTypes";
export const useComponentTypes = () => {
    const { clientComponentTypes } = useClientComponentTypes();
    const { defaultComponentTypes } = useDefaultComponentTypes();
    const componentTypes = computed(() => {
        return [...clientComponentTypes.value, ...defaultComponentTypes.value];
    });
    return {
        componentTypes,
    };
};
